export const formMessages = {
    required: () => 'Required',
    minLength: ({ $params }) => `Must be at least ${$params.minLength.min} characters.`,
    maxLength: ({ $params }) => `Must be at least ${$params.maxLength.max} characters.`,
    slugExists: () => 'This slug is exists',
    validationRedirect: () => 'This redirect is invalid',
    slugFormat: () => 'The post slug may only contain letters, numbers and dashes.',
    checkForH1: () => 'Contains H1 tag'
}
